import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const DragVertical = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb450__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb450__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M17.964 6h.072A2.939 2.939 0 0 1 21 8.964v.072A2.939 2.939 0 0 1 18.036 12h-.072A2.939 2.939 0 0 1 15 9.036v-.072A2.939 2.939 0 0 1 17.964 6m12 0h.072A2.939 2.939 0 0 1 33 8.964v.072A2.939 2.939 0 0 1 30.036 12h-.072A2.939 2.939 0 0 1 27 9.036v-.072A2.939 2.939 0 0 1 29.964 6m-12 15h.072A2.939 2.939 0 0 1 21 23.964v.072A2.939 2.939 0 0 1 18.036 27h-.072A2.939 2.939 0 0 1 15 24.036v-.072A2.939 2.939 0 0 1 17.964 21m12 0h.072A2.939 2.939 0 0 1 33 23.964v.072A2.939 2.939 0 0 1 30.036 27h-.072A2.939 2.939 0 0 1 27 24.036v-.072A2.939 2.939 0 0 1 29.964 21m-12 15h.072A2.939 2.939 0 0 1 21 38.964v.072A2.939 2.939 0 0 1 18.036 42h-.072A2.939 2.939 0 0 1 15 39.036v-.072A2.939 2.939 0 0 1 17.964 36m12 0h.072A2.939 2.939 0 0 1 33 38.964v.072A2.939 2.939 0 0 1 30.036 42h-.072A2.939 2.939 0 0 1 27 39.036v-.072A2.939 2.939 0 0 1 29.964 36"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
